/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Users.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Users
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    USER_LIST_CONTAINER_LOADED,
    USER_LIST_CONTAINER_UNLOADED,
    USER_LIST_TABLE_LOADED,
    USER_LIST_TABLE_UNLOADED,
    USER_LIST_CHANGE_STATUS,
    USER_SELECT_ROW,
    USER_ADD,
    USER_EDIT,
    USER_DELETE,
    USER_OPEN_WARNING,
    USER_CLOSE_WARNING,
    USER_EDIT_CONTAINER_LOADED,
    USER_EDIT_CONTAINER_UNLOADED,
    USER_EDIT_FORM_LOADED,
    USER_EDIT_FORM_UNLOADED,
    USER_OPEN_GENERATE_PASSWORD,
    USER_CLOSE_GENERATE_PASSWORD,
    USER_OPEN_GENERATE_PASSWORD_RESULTS,
    USER_CLOSE_GENERATE_PASSWORD_RESULTS,
    USER_EDIT_DATA_LOAD,
    USER_DRAW_ROLE_SWITCHES,
    USER_UPDATE_FIELD,
    USER_EDIT_CONTAINER_SUBMIT,
    USER_EDIT_CONTAINER_CANCEL,
    USER_UPDATE_CHECK
} from '../constants/actionTypeUsers';

import {
    USER_LOGGED_IN,
    USER_LOGGED_OUT
} from '../constants/actionTypes';

const defaultState = {
    refreshList: false,
    users: [],
    userstatuses: [],
    companies: [],
    danger: false,
    generatePassword: false,
    userid: 0,
    companyid: 0,
    username: '',
    passwordexists: '',
    newpassword: '',
    refreshedpassword: '',
    firstname: '',
    middlename: '',
    lastname: '',
    userstatusid: 0, 
    avatarid: 0,
    jobtitle: '',
    email: '',
    phone: '',
    lastlogin: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case USER_LOGGED_IN:
            return action.payload;
        case USER_LOGGED_OUT:
            return null;
        case USER_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                users: action.payload[0] ? action.payload[0].users : [],
                userstatuses: action.payload[1] ? action.payload[1].userstatuses : [],
                companies: action.payload[2] ? action.payload[2].companies : []
            }
        case USER_LIST_CHANGE_STATUS:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                users: action.payload ? action.payload.users : []
            }
        case USER_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case USER_SELECT_ROW:
            return {
                ...state,
                userid: action.id
            }
        case USER_ADD:
            return {
                ...state
            }
        case USER_EDIT:
            return {
                ...state,
                userid: action.id
            }
        case USER_DELETE:
            return {
                ...state,
                userid: null
            }
        case USER_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case USER_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case USER_DRAW_ROLE_SWITCHES:
            return {
                ...state,
                roleSwitches: action.payload ? action.payload : []
            }
        case USER_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                userstatuses: action.payload[1] ? action.payload[1].userstatuses : [],
                companies: action.payload[2] ? action.payload[2].companies : [],
                roles: action.payload[3] ? action.payload[3].records : [],
                userid: action.payload[0] ? action.payload[0].userid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                username: action.payload[0] ? action.payload[0].username : '',
                passwordexists: action.payload[0] ? action.payload[0].passwordexists : '',
                firstname: action.payload[0] ? action.payload[0].firstname : '',
                middlename: action.payload[0] ? action.payload[0].middlename : '',
                lastname: action.payload[0] ? action.payload[0].lastname : '',
                userstatusid: action.payload[0] ? action.payload[0].userstatusid : 0,
                avatarid: action.payload[0] ? action.payload[0].avatarid : 0,
                jobtitle: action.payload[0] ? action.payload[0].jobtitle : '',
                email: action.payload[0] ? action.payload[0].email : '',
                phone: action.payload[0] ? action.payload[0].phone : '',
                lastlogin: action.payload[0] ? action.payload[0].lastlogin : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                generatePassword: false,
                newpassword: '',
                refreshedPassword: ''
            }
        case USER_EDIT_DATA_LOAD:
            return {
                ...state,
                userid: action.payload ? action.payload.userid : 0,
                companyid: action.payload ? action.payload.companyid : 0,
                username: action.payload ? action.payload.username : '',
                passwordexists: action.payload ? action.payload.passwordexists : '',
                firstname: action.payload ? action.payload.firstname : '',
                middlename: action.payload ? action.payload.middlename : '',
                lastname: action.payload ? action.payload.lastname : '',
                userstatusid: action.payload ? action.payload.userstatusid : 0,
                avatarid: action.payload ? action.payload.avatarid : 0,
                jobtitle: action.payload ? action.payload.jobtitle : '',
                email: action.payload ? action.payload.email : '',
                phone: action.payload ? action.payload.phone : '',
                lastlogin: action.payload ? action.payload.lastlogin : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : '',
                generatePassword: false,
                newpassword: '',
                refreshedPassword: ''
            }
        case USER_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case USER_OPEN_GENERATE_PASSWORD:
            return {
                ...state,
                generatePassword: true
            }
        case USER_CLOSE_GENERATE_PASSWORD:
            return {
                ...state,
                generatePassword: false
            }
        case USER_OPEN_GENERATE_PASSWORD_RESULTS:
            return {
                ...state,
                resultModal: true,
                refreshedpassword: action.newpassword,
                newpassword: '',
                passwordexists: true
            }
        case USER_CLOSE_GENERATE_PASSWORD_RESULTS:
            return {
                ...state,
                resultModal: false
            }
        case USER_UPDATE_FIELD:
            return { ...state, [action.key]: action.value };
        case USER_UPDATE_CHECK:
            console.log('IN USER_UPDATE_CHECK');
            console.log(action.index);
            console.log(action.checked);
            return {
                ...state,
                roleid: [action.checked, false, false, false]
            };
        case USER_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case USER_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case USER_LIST_CONTAINER_UNLOADED:
        case USER_LIST_TABLE_UNLOADED:
        case USER_EDIT_CONTAINER_UNLOADED:
        case USER_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Users.js